var map = {
	"./checkout-ratio.gif": "35fc",
	"./comparison-periods.gif": "78e0",
	"./global-queries.gif": "a0a5",
	"./intro.gif": "9be8",
	"./multiselectable-filters.gif": "f9a9",
	"./no-results-ratio.gif": "b52a",
	"./queries-distribution.gif": "c9a7",
	"./user-metrics.gif": "6053"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eb5f";